const get_tokens = require('./get_tokens').default
const { createCodeVerifier, createCodeChallenge } = require('./pkce')
const { createState } = require("./state")

const stateStore = new Map();

/**
 * Handles the OAuth flow and returns user data
 * @param {Object} params - The parameters object
 * @param {string} params.environment - The environment URL
 * @param {string} params.client_id - The client ID
 * @param {string} params.client_secret - The client secret
 * @param {string} params.redirect_url - The redirect URL
 * @param {Object} params.req - Express request object
 * @returns {Promise<Object>} User data object or redirect information
 * 
 */
 const plugin_client_id = process.env.REACT_APP_PLUGIN_CLIENTID;
 const plugin_client_secret = process.env.REACT_APP_PLUGIN_CLIENTSECRET;
 const plugin_environment = process.env.REACT_APP_PLUGIN_ENVIRONMENT; 
 const plugin_redirecturi = process.env.REACT_APP_PLUGIN_REDIRECTURI;

// const secretKey = 'your_secret_key';

async function handleOAuthFlow({ environment, client_id, client_secret, redirect_url, req }) {
    try {
        let state;
        let codeVerifier;
        let codeChallenge;
              
        if (!req.code || !req.state) {
            if (req.state) {
                stateStore.delete(req.state);
            }

            codeVerifier = createCodeVerifier();
            codeChallenge = createCodeChallenge(codeVerifier);
            state = createState();
            stateStore.set(state, codeVerifier);
            sessionStorage.setItem(state, codeVerifier);
            
            const authBaseURL = `${plugin_environment}/a/consumer/api/v0/oidc/auth`;
            const scopesParameterEncoded = `?scope=${encodeURIComponent('openid profile https://api.banno.com/consumer/auth/user.profile.readonly')}`;
            const responseTypeParameter = `&response_type=code`;
            const clientIdParameter = `&client_id=${plugin_client_id}`;
            const redirectUriParameterEncoded = `&redirect_uri=${encodeURIComponent(plugin_redirecturi)}`;

            const stateParameter = `&state=${state}`;

            const claims = {
                'https://api.banno.com/consumer/claim/institution_id': null,
                'https://api.banno.com/consumer/claim/customer_identifier': null,
                'https://api.banno.com/consumer/claim/phone_numbers': null
            };

            const claimsToRequest = {
                id_token: claims,
                userinfo: claims
            };


            const claimsParameterValue = encodeURIComponent(JSON.stringify(claimsToRequest));
            const claimsParameter = `&claims=${claimsParameterValue}`;
            const codeChallengeParameter = `&code_challenge=${codeChallenge}`;
            const codeChallengeMethodParameter = `&code_challenge_method=S256`;

            const authorizationURL = `${authBaseURL}${scopesParameterEncoded}${responseTypeParameter}${clientIdParameter}${redirectUriParameterEncoded}${stateParameter}${codeChallengeParameter}${codeChallengeMethodParameter}${claimsParameter}`;
            

            return {
                results: "REDIRECT",
                redirect_url: authorizationURL,
                state: state,
                code_verifier: codeVerifier
            };
        }
        state = req.state;
        codeVerifier = stateStore.get(state);
        codeVerifier = sessionStorage.getItem(state);
        //stateStore.delete(state);

        const auth_code = req.code;
        
        const my_tokens = await get_tokens(plugin_environment, plugin_client_id, plugin_client_secret, auth_code, plugin_redirecturi, codeVerifier);
        const { access_token, id_token } = my_tokens;

        const user_id = id_token.sub;

        // Define the partial key name to search for
        const partialKey = 'customer_identifier';
        const partialKey2 = 'phone_numbers';

        // Find the full key name
        const fullKey = findKeyByPartialName(id_token, partialKey);    
        const fullKey2 = findKeyByPartialName(id_token, partialKey2);
        return {
            results: "OK",
            error: "",
            member_number: id_token[fullKey] || "",
            // first_name: user_data.firstName || "",
            // middle_name: user_data.middleName || "",
            // last_name: user_data.lastName || "",
            // user_type: user_data.userType || "",
            // user_name: user_data.username || "",
            phone_number: id_token[fullKey2] || ""
        };
    } catch (error) {
        return {
            results: "ERROR",
            error: error.message,
            member_number: "",
            first_name: "",
            middle_name: "",
            last_name: "",
            user_type: "",
            user_name: "",
            phone_number: ""
        };
    }
}

function findKeyByPartialName(jsonData, partialKey) {
    for (const key in jsonData) {
        if (key.includes(partialKey)) {
            return key;
        }
    }
    return null;
}

module.exports = { handleOAuthFlow };